<template>
  <div class="flex items-center justify-center pt-64">
    <div class="text-center">
      <svg
        width="36"
        height="24"
        viewBox="0 0 36 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="inline-block mb-5"
      >
        <path
          d="M2 0C3.104 0 4 0.896 4 2C4 3.104 3.104 4 2 4C0.896 4 0 3.104 0 2C0 0.896 0.896 0 2 0ZM2 10C3.104 10 4 10.896 4 12C4 13.104 3.104 14 2 14C0.896 14 0 13.104 0 12C0 10.896 0.896 10 2 10ZM2 20C3.104 20 4 20.896 4 22C4 23.104 3.104 24 2 24C0.896 24 0 23.104 0 22C0 20.896 0.896 20 2 20ZM34.129 10C35.159 10 36.001 10.842 36.001 11.872V12.128C36.001 13.158 35.159 14 34.129 14H9.871C8.841 14 8.001 13.158 8.001 12.128V11.872C8.001 10.842 8.841 10 9.871 10H34.129ZM34.129 20C35.159 20 36.001 20.842 36.001 21.872V22.128C36.001 23.158 35.159 24 34.129 24H9.871C8.841 24 8.001 23.158 8.001 22.128V21.872C8.001 20.842 8.841 20 9.871 20H34.129ZM34.129 0C35.159 0 36.001 0.842 36.001 1.872V2.128C36.001 3.158 35.159 4 34.129 4H9.871C8.841 4 8.001 3.158 8.001 2.128V1.872C8.001 0.842 8.841 0 9.871 0H34.129Z"
          fill="#8C8C8C"
        />
      </svg>
      <h1 class="mb-2 text-gray-700">Keine Mappen vorhanden</h1>
      <p class="text-sm text-gray-500">
        Legen Sie individuelle Mappen aus Themen und Terminen an und speichern
        Sie diese für Ihr Team.
      </p>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({});
</script>
